import type { NpsRole } from '@/shared/types/nps';

export const NPS_ROLE_LABEL: Record<NpsRole, string> = {
  admin: 'Administrador',
  org: 'Organização',
  user: 'Usuário',
};

export const NPS_ROLES: NpsRole[] = ['admin', 'org', 'user'];

/** Perfil exibido. `user` ganha de `org` quando o Keycloak devolve as duas. Sem role, não inventa Organização. */
export function primaryNpsRole(roles: NpsRole[] | undefined): NpsRole | undefined {
  if (roles?.includes('admin')) return 'admin';
  if (roles?.includes('user')) return 'user';
  if (roles?.includes('org')) return 'org';
  return undefined;
}
